<template>
    <div
        :class="classList"
        @click.stop.prevent="onClick()"
    >
        <svg
            class="afu-h-2 afu-w-2"
            stroke="currentColor"
            fill="none"
            viewBox="0 0 8 8"
        >
            <path
                stroke-linecap="round"
                stroke-width="1.5"
                d="M1 1l6 6m0-6L1 7"
            />
        </svg>
    </div>
</template>

<script>
    export default {
        name: 'C1TagCloseBtn',

        props: {
            localVariant: {
                type: String,
                default: null,
            },

            isOutline: {
                type: Boolean,
                default: null,
            },
        },

        computed: {
            classList() {
                return [
                    this.getDefaultClass,
                    this.getTextColorClass,
                ];
            },

            getDefaultClass() {
                return 'af-tag-times afu-flex-shrink-0 afu--mr-0.5 afu-ml-2 afu-px-0 afu-py-2 afu-inline-flex';
            },

            getTextColorClass() {
                if (this.isOutline) {
                    return `afu-text-${this.localVariant}-dark focus:afu-text-${this.localVariant}-dark`;
                }

                return this.localVariant ? 'afu-text-white focus:afu-text-white' : 'afu-text-neutral-dark focus:afu-text-neutral-dark';
            },
        },

        methods: {
            onClick() {
                this.$emit('click');
            },
        },
    };
</script>
